import { gql } from '@apollo/client';

import CourseListItemFragment from '../fragments/courseListItemFragment';

export default gql`
  query Courses {
    courses @rest(type: "Course", path: "courses") {
      ...CourseListItem
    }
  }
  ${CourseListItemFragment}
`;
